module.exports = __webpack_public_path__ + "media/components/country-flag/static/ga-215902677758c321e8a7e3e6f5018c6c.svg";